export const COMMERCIALS_LIST_REQUEST = 'COMMERCIALS_LIST_REQUEST';
export const COMMERCIALS_LIST_SUCCESS = 'COMMERCIALS_LIST_SUCCESS';
export const COMMERCIALS_LIST_FAIL = 'COMMERCIALS_LIST_FAIL';

export const COMMERCIAL_DETAIL_REQUEST = 'COMMERCIAL_DETAIL_REQUEST';
export const COMMERCIAL_DETAIL_SUCCESS = 'COMMERCIAL_DETAIL_SUCCESS';
export const COMMERCIAL_DETAIL_FAIL = 'COMMERCIAL_DETAIL_FAIL';

export const COMMERCIAL_FILE_UPLOAD_REQUEST = 'COMMERCIAL_FILE_UPLOAD_REQUEST';
export const COMMERCIAL_FILE_UPLOAD_SUCCESS = 'COMMERCIAL_FILE_UPLOAD_SUCCESS';
export const COMMERCIAL_FILE_UPLOAD_FAIL = 'COMMERCIAL_FILE_UPLOAD_FAIL';
export const COMMERCIAL_FILE_UPLOAD_RESET = 'COMMERCIAL_FILE_UPLOAD_RESET';

export const COMMERCIAL_DELETE_REQUEST = 'COMMERCIAL_DELETE_REQUEST';
export const COMMERCIAL_DELETE_SUCCESS = 'COMMERCIAL_DELETE_SUCCESS';
export const COMMERCIAL_DELETE_FAIL = 'COMMERCIAL_DELETE_FAIL';
export const COMMERCIAL_DELETE_RESET = 'COMMERCIAL_DELETE_RESET';

export const COMMERCIAL_UPDATE_REQUEST = 'COMMERCIAL_UPDATE_REQUEST';
export const COMMERCIAL_UPDATE_SUCCESS = 'COMMERCIAL_UPDATE_SUCCESS';
export const COMMERCIAL_UPDATE_FAIL = 'COMMERCIAL_UPDATE_FAIL';
export const COMMERCIAL_UPDATE_DETAILS_RESET =
    'COMMERCIAL_UPDATE_DETAILS_RESET';
